import Modal from "../Base/Modal";
import styled from "styled-components";
import moment from "moment";
import { useState, useEffect } from "react";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 20px;
  width: 500px;

  .headerTabs {
    display: flex;
    gap: 20px;

    .tab {
      font-weight: 700;
      font-size: 20px;
      color: #004576;
      cursor: pointer;
    }

    .activeTab {
      border-bottom: 3px solid #48c8f4;
    }

    .closeButtonModal {
      margin-left: 154px;
      font-size: 20px;
      cursor: pointer;
    }
  }

  .accountsTab {
    display: flex;

    .accountIdsSection {
      margin-top: 30px;
      padding-right: 40px;
      border-right: 1px solid #004576;
      max-height: 470px;
      overflow-y: auto;
      width: 33%;

      &::-webkit-scrollbar {
        width: 10px;
        border: none;
      }

      .accountId {
        color: #004576;
        font-weight: 700;
        font-size: 20px;
        width: fit-content;
        margin-top: 30px;
        cursor: pointer;
      }

      .active {
        border-bottom: 3px solid #48c8f4;
      }
    }

    .infoSection {
      margin-top: 60px;
      padding-left: 40px;
      width: 100%;
      display: block;

      .info {
        margin-top: 15px;
        display: flex;
        width: 100%;

        .header {
          color: #211c1d;
          font-weight: 400;
          font-size: 12px;
          width: 30%;
          margin-top: 3px;
        }

        .text {
          color: #211c1d;
          font-weight: 400;
          font-size: 16px;
        }
      }

      .progressBar {
        display: flex;
        gap: 10px;

        .progress {
          width: 50%;

          .name {
            text-align: center;
          }

          .bar {
            width: 100%;
            height: 20px;
            border-radius: 50px;
            background-color: #dfdfdf;
          }

          .active {
            background-color: #48c8f4;
          }
        }
      }
    }
  }

  .scrollWrapper {
    max-height: 500px;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 20px;
  }

  .clientName {
    font-weight: 700;
    font-size: 16px;
    color: #211c1d;
    margin-top: 24px;
  }

  .infoSection {
    display: flex;
    margin-top: 20px;
    gap: 20px;

    .info {
      .header {
        font-weight: 700;
        font-size: 12px;
        color: #004576;
        margin-bottom: 5px;
      }

      .text {
        font-weight: 400;
        font-size: 16px;
        color: #3a3a3d;
      }
    }

    .email {
      .header {
        font-weight: 400;
        font-size: 12px;
        color: #211c1d;
      }

      .info {
        font-weight: 400;
        font-size: 16px;
        color: #008df1;
        cursor: pointer;
        text-decoration: underline;
      }
    }

    .phone {
      .header {
        font-weight: 400;
        font-size: 12px;
        color: #211c1d;
      }

      .info {
        font-weight: 400;
        font-size: 16px;
        color: #3a3a3d;
      }
    }
  }

  .notesSection {
    margin-top: 20px;

    .notesText {
      font-weight: 700;
      font-size: 16px;
      color: #211c1d;
    }

    .postButtonContainer {
      display: flex;
      justify-content: end;

      button {
        margin-top: 10px;
        background-color: #004576;
        border: none;
        color: white;
        padding: 10px 20px;
        border-radius: 5px;
        cursor: pointer;
      }
    }

    .errorMessage {
      display: flex;
      justify-content: end;
      color: red;
      font-size: 12px;
    }

    .successMessage {
      color: green;
      font-size: 14px;
      transition: display 0.3s;
    }

    .noteInput {
      background-color: transparent;
      border: 1px solid #004576;
      border-radius: 8px;
      width: 91.5%;
      padding: 20px 20px;
      padding: 1;
      margin-top: 10px;
    }

    .notesContainer {
      margin-top: 10px;
      padding: 20px 20px;
      border: 1px solid #004576;
      border-radius: 8px;

      .message {
        overflow: hidden;
      }
    }
  }
`;

const AdvisorIndividualClientSummaryModal = ({
  data,
  isAdvisorIndividualClientSummaryModalShow,
  advisorIndividualClientSummaryModalOnClose,
  postNote,
  individualAccountNotes,
  individualAccountDetails,
  setAdvisorNote,
}) => {
  const [postInput, setPostInput] = useState("");
  const [postErrorMessage, setPostErrorMessage] = useState("");
  const [isAccountsTabVisible, setIsAccountsTabVisible] = useState(false);
  const [activeUserId, setActiveUserId] = useState("");
  const [activeUserData, setActiveUserData] = useState({});
  const [isSuccessPostMessageVisible, setIsSuccessPostMessageVisible] =
    useState(false);

  const handlePostInputChange = (e) => {
    setPostInput(e.target.value);
  };

  const formatPhoneNumber = (str) => {
    let cleaned = ("" + str).replace(/\D/g, "");
    let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      return "(" + match[1] + ") " + match[2] + "-" + match[3];
    }

    return null;
  };

  const handlePostClick = () => {
    if (postInput.trim() === "") {
      setPostErrorMessage("Please type something in the box");
    } else {
      setPostErrorMessage("");
      postNote(postInput);
      setPostInput("");
    }
  };

  useEffect(() => {
    if (individualAccountDetails?.hasOwnProperty("accountIds")) {
      setActiveUserId(individualAccountDetails?.accountIds[0]);
      let initialData = individualAccountDetails?.accounts?.filter(
        (data) => data.externalId === individualAccountDetails?.accountIds[0]
      );
      setActiveUserData(initialData[0]);
    }
  }, [individualAccountDetails]);

  useEffect(() => {
    setIsAccountsTabVisible(false);
  }, []);

  useEffect(() => {
    if (setAdvisorNote?.hasOwnProperty("noteId")) {
      setIsSuccessPostMessageVisible(true);
      setTimeout(() => {
        setIsSuccessPostMessageVisible(false);
      }, 3000);
    }
  }, [setAdvisorNote]);

  const handleUserIdClick = (userId) => {
    setActiveUserId(userId);
    let activeData = individualAccountDetails?.accounts?.filter(
      (data) => data.externalId === userId
    );
    setActiveUserData(activeData[0]);
  };

  const handleMailClick = (mailId) => {
    window.open(`mailto:${mailId}`);
  };

  let intlDateObj = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/New_York",
  });

  return (
    <Modal
      show={isAdvisorIndividualClientSummaryModalShow}
      onClose={advisorIndividualClientSummaryModalOnClose}
    >
      <Wrapper>
        <div className="headerTabs">
          <div
            className={`tab ${!isAccountsTabVisible && "activeTab"}`}
            onClick={() => {
              setIsAccountsTabVisible(false);
            }}
          >
            Client Summary
          </div>
          <div
            className={`tab ${isAccountsTabVisible && "activeTab"}`}
            onClick={() => {
              setIsAccountsTabVisible(true);
            }}
          >
            Accounts ({individualAccountDetails?.numberOfAccounts})
          </div>
          <div
            className="closeButtonModal"
            onClick={advisorIndividualClientSummaryModalOnClose}
          >
            X
          </div>
        </div>
        {!isAccountsTabVisible ? (
          <>
            <div className="scrollWrapper">
              <div className="clientName">{data?.clientName || ""}</div>
              <div className="infoSection">
                <div className="info">
                  <div className="header">Total AUM</div>
                  <div className="text">
                    ${parseFloat(data?.totalAUM || 0).toFixed(2)}
                  </div>
                </div>
                <div className="info">
                  <div className="header">Total Gain/Loss</div>
                  <div>${parseFloat(data?.totalGainLoss || 0).toFixed(2)}</div>
                </div>
                <div className="info">
                  <div className="header">Total ROI</div>
                  <div>
                    {data?.totalROI > 0 ? "+" : ""}
                    {parseFloat(data?.totalROI * 100 || 0).toFixed(2)}%
                  </div>
                </div>
              </div>
              <div className="infoSection">
                <div className="email">
                  <div className="header">Email</div>
                  <div
                    className="info"
                    onClick={() => handleMailClick(data?.email)}
                  >
                    {data?.email || ""}
                  </div>
                </div>
                <div className="phone">
                  <div className="header">Phone</div>
                  <div className="info">
                    {formatPhoneNumber(data?.phone) || ""}
                  </div>
                </div>
              </div>
              <div className="notesSection">
                <div className="notesText">Notes</div>
                <div>
                  <input
                    className="noteInput"
                    placeholder="Type to create a new note"
                    value={postInput}
                    onChange={handlePostInputChange}
                  />
                  <div className="postButtonContainer">
                    <button onClick={handlePostClick}>Post</button>
                  </div>
                  {isSuccessPostMessageVisible && (
                    <div className="successMessage">
                      Note posted successfully
                    </div>
                  )}
                  <div className="errorMessage">{postErrorMessage}</div>
                </div>
                {individualAccountNotes &&
                  individualAccountNotes.length > 0 &&
                  individualAccountNotes.map((data) => (
                    <div className="notesContainer">
                      <div>Submitted by: {data?.submittedBy}</div>
                      <div>
                        Date:{" "}
                        {moment(moment.utc(data?.date).toDate()).format(
                          "MM/DD/YYYY"
                        )}
                      </div>
                      <div>
                        Time:{" "}
                        {moment(moment.utc(data?.date).toDate()).format(
                          "hh:mm a"
                        )}
                      </div>
                      <br></br>
                      <div className="message">{data.message}</div>
                    </div>
                  ))}
              </div>
            </div>
          </>
        ) : (
          <div className="accountsTab">
            <div className="accountIdsSection">
              {individualAccountDetails?.accountIds &&
                individualAccountDetails?.accountIds.length > 0 &&
                individualAccountDetails?.accountIds.map((data, index) => (
                  <div
                    className={`accountId ${activeUserId === data && "active"}`}
                    onClick={() => handleUserIdClick(data)}
                  >
                    {data}
                  </div>
                ))}
            </div>
            <div className="infoSection">
              <div className="progressBar">
                <div className="progress">
                  <div className="name">Funded</div>
                  <div
                    className={`bar ${
                      (activeUserData?.status === "Funded" ||
                        activeUserData?.status === "Active") &&
                      "active"
                    }`}
                  ></div>
                </div>
                <div className="progress">
                  <div className="name">Active</div>
                  <div
                    className={`bar ${
                      activeUserData?.status === "Active" && "active"
                    }`}
                  ></div>
                </div>
              </div>
              <div className="info">
                <div className="header">Date Opened</div>
                <div className="text">
                  {new Date(activeUserData?.dateOpened).toLocaleDateString()}
                </div>
              </div>
              <div className="info">
                <div className="header">Custodian</div>
                <div className="text">{activeUserData?.custodianName}</div>
              </div>
              <div className="info">
                <div className="header">Status</div>
                <div className="text">{activeUserData?.status}</div>
              </div>
              <div className="info">
                <div className="header">AUM</div>
                <div className="text">
                  ${parseFloat(activeUserData?.aum).toFixed(2)}
                </div>
              </div>
              <div className="info">
                <div className="header">Gain/Loss</div>
                <div className="text">
                  ${parseFloat(activeUserData?.gainLoss).toFixed(2)}
                </div>
              </div>
              <div className="info">
                <div className="header">ROI</div>
                <div className="text">
                  {parseFloat(activeUserData?.roi).toFixed(2)}%
                </div>
              </div>
              <div className="info">
                <div className="header">RIA</div>
                <div className="text">{activeUserData?.riaName}</div>
              </div>
              <div className="info">
                <div className="header">Advisor</div>
                <div className="text">{activeUserData?.advisorName}</div>
              </div>
              <div className="info">
                <div className="header">Account Type</div>
                <div className="text">{activeUserData?.accountType}</div>
              </div>
              <div className="info">
                <div className="header">Custodian</div>
                <div className="text">{activeUserData?.custodianName}</div>
              </div>
            </div>
          </div>
        )}
      </Wrapper>
    </Modal>
  );
};

export default AdvisorIndividualClientSummaryModal;
